export enum MaxLimitMarginBoundaryType {
    Below,
    Above,
    BelowAndAbove
}